<template>
    <LayoutDefault variant="black">
        <OrganismAlphabetList
            @search="update"
            attribute="name"
            isPublishedAttribute="is_published"
            routeName="people.view"
            compare-attribute="compare"
            :data="people"
        />
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import {mapActions, mapState} from "vuex";
import SingleSearchMixin from "../mixins/single-search";
import OrganismAlphabetList from "../components/global/organisms/OrganismAlphabetList.vue";

export default {
    name: "PageArtists",
    components: {OrganismAlphabetList, LayoutDefault},
    mixins: [SingleSearchMixin],
    mounted() {
        this.setType('people')
        this.enableSingleSearch('people')
        this.searchPeople({query: ''});
    },
    methods: {
        ...mapActions('people', {
            searchPeople: 'search'
        }),
        ...mapActions('menu', [
            'updateQuery'
        ]),
        update(searchedText) {
            this.updateQuery(searchedText)
        }
    },
    computed: {
        ...mapState('people', {
            people: 'peoples'
        }),
    }
}
</script>

<style scoped lang="scss">
</style>
